module.exports = __webpack_public_path__ + "img/電気回路_6_3.9f31f347.png";